<template>
  <small :id="`driver-tooltip-target-${_uid}`" class="tag is-abbr-like">
    {{ item.name | limitShow }}
    <tooltip :target="`driver-tooltip-target-${_uid}`" triggers="hover focus" noninteractive custom-class="board-tooltip">
      Ad Soyad: {{ item.name }} <br>
      Telefon: {{ item.phone | phone }} <br>
      Toplam Sefer: {{ item.total_voyage }} <br>
      Toplam Süre: {{ item.total_time | humanTime }} <br>
      Toplam Km: {{ item.total_distance }} <br>
    </tooltip>
  </small>
</template>
<script>
import { BTooltip as Tooltip } from 'bootstrap-vue'

export default {
  name: 'DriverListItem',
  components: { Tooltip },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
